// extracted by mini-css-extract-plugin
export var arrows = "_54-5";
export var decrementer = "_54-9";
export var disabled = "_54-3";
export var error = "_54-1";
export var hiddenText = "_54-a";
export var incrementer = "_54-8";
export var input = "_54-7";
export var inputWrapper = "_54-0";
export var readonly = "_54-2";
export var regular = "_54-6";
export var small = "_54-4";